export default "__VITE_ASSET__DhMiKGYu__"